import { combineReducers } from 'redux';
import userReducer from './userReducer';
import contentReducer from './contentReducer';
import workspaceReducer from './workspaceReducer';
import entryReducer from './entryReducer';
import assetsReducer from './assetsReducer';
import appsReducer from './appStudioReducer';

// Combine Reducers
const rootReducer = combineReducers({
  user:userReducer,
  form :contentReducer,
  workspace:workspaceReducer,
  entry: entryReducer,
  assets:assetsReducer,
  apps:appsReducer,

  // Add other reducers here if you have more
});

export default rootReducer;